const handleLinkMimic = (el, href) => {
	el.style.cursor = 'pointer';
	el.addEventListener('click', (e) => {
		if (e.shiftKey) {
			// new window
			window.open = href;
		} else if (e.metaKey) {
			// new tab
			const a = document.createElement('a');
			a.href = href;
			a.setAttribute('target', '_blank');
			a.click();
		} else {
			window.location = href;
		}
	});
};

// the following is used for non-vue applications when a directive isn't possible
const initializeLinkMimic = function () {
	const linkMimics = document.querySelectorAll('[data-link-mimic]');
	Array.prototype.forEach.call(linkMimics, (el) => {
		if (el.hasAttribute('data-link-mimic')) {
			const href = el.getAttribute('data-link-mimic');
			handleLinkMimic(el, href);
		}
	});
};
document.addEventListener('lichen:loaded', initializeLinkMimic);

import Vue from 'vue';
Vue.directive('clo-link-mimic', {
	inserted: function (el, binding) {
		handleLinkMimic(el, binding.value);
	},
});
